<template>
  <div class="custom-modal">
    <div class="modal-body">
      <div class="information-form" v-if="form != null">
        <div class="information-form-input">
          <label>{{ $t("addLanguage.language") }}</label>
          <el-select v-model="form.languageId"  :placeholder="$t('choose')">
            <el-option v-for="item in languages" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
          <span>{{ $errorMessage("languageId", validationErrors) }}</span>
        </div>
        <div class="information-form-input">
          <label>{{ $t("addLanguage.speaking") }}</label>
         <el-select v-model="form.speaking" v-if="getEnums.find((x) => x.title == 'UserLanguageLevel').enums" clearable @clear="form.speaking = null" filterable :placeholder="$t('choose')">
            <el-option v-for="(item, index) in getEnums.find((x) => x.title == 'UserLanguageLevel').enums" :key="'language-level-type-' + index" :value="item.key" :label="item.displayName" ></el-option>
          </el-select>
          <span>{{ $errorMessage("speaking", validationErrors) }}</span>
        </div>
          <div class="information-form-input">
          <label>{{ $t("addLanguage.reading") }}</label>
         <el-select v-model="form.reading" v-if="getEnums.find((x) => x.title == 'UserLanguageLevel').enums" clearable @clear="form.reading = null" filterable :placeholder="$t('choose')">
            <el-option v-for="(item, index) in getEnums.find((x) => x.title == 'UserLanguageLevel').enums" :key="'language-level-type-' + index" :value="item.key" :label="item.displayName" ></el-option>
          </el-select>
          <span>{{ $errorMessage("reading", validationErrors) }}</span>
        </div>
          <div class="information-form-input">
          <label>{{ $t("addLanguage.writing") }}</label>
         <el-select v-model="form.writing" v-if="getEnums.find((x) => x.title == 'UserLanguageLevel').enums" clearable @clear="form.writing = null" filterable :placeholder="$t('choose')">
            <el-option v-for="(item, index) in getEnums.find((x) => x.title == 'UserLanguageLevel').enums" :key="'language-level-type-' + index" :value="item.key" :label="item.displayName" ></el-option>
          </el-select>
          <span>{{ $errorMessage("writing", validationErrors) }}</span>
        </div>
      </div>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("close") }}</el-button>
        <el-button v-if="form.id != null" @click="deleteMe" type="danger"> {{ $t("delete")}} </el-button>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveLanguage'" @click="saveLanguage">{{ $t('save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";
export default {
  props: ["id"],
  name: "AddJob",
  data() {
    return {
      moment,
      form: {
        id: null,
        languageId: null,
        speaking: null,
        writing: null,
        reading: null,
      },
      loading: false,
      timeout: null,
      validationErrors: []
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    languages(){
      return this.$store.getters.getUserLanguages;
    },
    getEnums(){
      return this.$store.getters.getEnums;
    },
  },

  created() {
    if (this.id != null && this.id != undefined) {
      var fIndex = this.user.languages.findIndex(x => x.id == this.id);
      if (fIndex != -1) {
        this.form = this.user.languages[fIndex];
      }
    }
  },
  methods: {
    deleteMe() {
      this.$emit("closeDialog");
      this.$emit("deleteMe", this.form.id);
    },
    async saveLanguage() {
      this.loading = "saveLanguage";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("addUpdateAccountLanguage", {
          ...this.form
        });
        this.validationErrors = res.data.validationErrors;
        if (!res.data.hasError) {
          await this.$store.dispatch("getUser");
          this.form = res.data.data.item;
        }
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/account/AddLanguage.vue